module.exports = __webpack_public_path__ + "img/result.732b2f72.png";